<template>
	<v-tooltip
		:top="top"
		:right="right"
		:bottom="bottom"
		:left="left"
		:disabled="disabled"
	>
		<template v-slot:activator="{ on:tooltip, attrs }">
			<span v-bind="attrs" v-on="{...tooltip}" :class="contentClass">
				<slot></slot>
			</span>
		</template>
		{{text}}
	</v-tooltip>
</template>

<script>
export default {
	props: {
		text: { type: String },
		contentClass: { type: String },
		top: { type: Boolean, default: true },
		right: { type: Boolean },
		bottom: { type: Boolean },
		left: { type: Boolean },
		disabled: { type: Boolean },
	}
}
</script>